import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import './Hero.css';

const Hero = () => {
  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="hero">
      <div className="container">
        <div className="hero-content">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, ease: [0.25, 0.46, 0.45, 0.94] }}
            className="hero-text"
          >
            <div className="hero-badge">
              <span>OFFER FOR BEST INTERIOR</span>
            </div>
            <h1 className="hero-title">
              We Craft Your<br />
              Dream <span className="highlight">Interior!</span>
            </h1>
            <p className="hero-subtitle">
              Kerala's expert interior designer with years of experience creating 
              charming, ambient spaces for homes, hotels, offices, and commercial spaces. 
              Transform your space into something extraordinary.
            </p>
            <div className="hero-actions">
              <button className="btn btn-primary" onClick={scrollToContact}>
                Explore Now
                <ArrowRight size={18} />
              </button>
            </div>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, delay: 0.3, ease: [0.25, 0.46, 0.45, 0.94] }}
            className="hero-image-container"
          >
            <img 
              src="/images/livingroom2.jpg" 
              alt="Modern Interior Design by JMJ"
              className="hero-main-image"
            />
          </motion.div>
        </div>
        
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.6 }}
          className="hero-partners"
        >
          <p className="partners-text">Trusted by a world-class interior team</p>
          <div className="partners-logos">
            <span>KANA</span>
            <span>batavia</span>
            <span>DIO</span>
            <span>MAISON</span>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;